import { render } from "./settings-page.vue?vue&type=template&id=544aa326"
import script from "./settings-page.vue?vue&type=script&lang=js"
export * from "./settings-page.vue?vue&type=script&lang=js"
script.render = render

export default script